export const DISABLED_COLOR = 'grays.6'; // eslint-disable-line import/prefer-default-export
export const DISABLED_TEXT = 'grays.4'; // eslint-disable-line import/prefer-default-export

export const STYLE = disabled => ({
  '&[disabled]': {
    boxShadow: 'none',
    backgroundColor: DISABLED_COLOR,
    color: DISABLED_TEXT,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: DISABLED_COLOR,
      color: DISABLED_TEXT,
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: DISABLED_COLOR,
      color: DISABLED_TEXT,
    },
  },
  ...(disabled && {
    boxShadow: 'none',
    backgroundColor: DISABLED_COLOR,
    color: DISABLED_TEXT,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: DISABLED_COLOR,
      color: DISABLED_TEXT,
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: DISABLED_COLOR,
      color: DISABLED_TEXT,
    },
  }),
});
